import { render } from "./OverviewComponent.vue?vue&type=template&id=ff903ea4&scoped=true"
import script from "./OverviewComponent.vue?vue&type=script&lang=js"
export * from "./OverviewComponent.vue?vue&type=script&lang=js"

import "./OverviewComponent.vue?vue&type=style&index=0&id=ff903ea4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff903ea4"],['__file',"resources/js/components/admin/dashboard/OverviewComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ff903ea4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ff903ea4', __exports__)) {
    api.reload('ff903ea4', __exports__)
  }
  
  module.hot.accept("./OverviewComponent.vue?vue&type=template&id=ff903ea4&scoped=true", () => {
    api.rerender('ff903ea4', render)
  })

}


export default __exports__